export default class HomePageAbstractServices {
  static getPWReferenceData() {
    logger.error(`HomePage:: getPWReferenceData() not implemented`);
  }

  static getMPReferenceData() {
    logger.error(`HomePage:: getMPReferenceData() not implemented`);
  }

  static getMembershipInfo() {
    logger.error(`HomePage:: getMembershipInfo() not implemented`);
  }
}
